import { IconPack } from "Explore/Config/Icons";
import styles from "./FavoriteEntityItem.module.scss";
import { IconButton } from "@mui/material";
import { numberRegex } from "Explore/Utils/numberRegex";
import FavoriteSnackbar from "Explore/Hook/FavoriteItemSnackbar";
import useFavoriteItem from "Explore/Hook/useFavoriteItem";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { LinkWrapper } from "Explore/Components";

const FavoriteVenueItem = ({ data }) => {
  const { deleteFavoriteItem, snackbarProps } = useFavoriteItem({
    itemId: data.id,
  });
  const [isDeleted, setIsDeleted] = useState(false);
  const statistics = [
    { value: data?.total_publication, icon: IconPack.publications },
    { value: data?.total_citation, icon: IconPack.citation },
    { value: data?.total_authors, icon: IconPack.unit_faculty_members },
    {
      value: data?.total_institutions,
      icon: IconPack.institution_outline_black,
    },
  ].filter((e) => !!e.value);

  const handleDelete = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    const result = await deleteFavoriteItem();
    if (result) {
      setIsDeleted(true); // Triggers exit animation
    }
  };

  return (
    <>
      <AnimatePresence>
        {!isDeleted && (
          <motion.div
            initial={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.5 }}
            style={{ width: "100%" }}
          >
            <LinkWrapper
              link={`/explore/venue/${data?.id}`}
              component={
                <div className={styles["container"]}>
                  <div className={styles["name--wrapper"]}>
                    <p className={styles["name"]}>{data?.name}</p>
                    <IconButton
                      color="error"
                      size="small"
                      onClick={(e) => handleDelete(e)}
                    >
                      {IconPack.delete}
                    </IconButton>
                  </div>
                  <div className={styles["bottom"]}>
                    <div className={styles["statistics"]}>
                      {statistics.map((item, index) => (
                        <div className={styles["statistics--item"]} key={index}>
                          {item.icon}
                          {numberRegex(item.value)}
                        </div>
                      ))}
                    </div>
                    <div className={styles["description--wrapper"]}>
                      <p className={styles["description"]}>
                        RESEARCH AREA: <br />
                        {data?.keywords?.join(", ")}
                      </p>
                    </div>
                  </div>
                </div>
              }
            />
          </motion.div>
        )}
      </AnimatePresence>
      <FavoriteSnackbar {...snackbarProps} />
    </>
  );
};

export default FavoriteVenueItem;
